export const SORT_SELECTION_HEADING_TEXT = "Sort By";

export const SORT_OPTION_RECOMMENDED_LABEL = "Recommended";
export const SORT_OPTION_PRICING_ASC_LABEL = "Price (low to high)";
export const SORT_OPTION_PRICING_DESC_LABEL = "Price (high to low)";

export const SORT_SELECTION_APPLY_BUTTON_LABEL = "Apply";
